(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('generateLinkButton', {
            templateUrl: 'app/components/generate-link-button/generate-link-button.html',
            controller: generateLinkButtonController,
            bindings: {
                label: '@',
                popoverText: '@?',
                buttonId: '@?',
                type: '@',
                storageKey: '@?',
                generateLink: '&',
                onError: '&?'
            }
        });

    generateLinkButtonController.$inject = ['$timeout', '$localStorage'];

    function generateLinkButtonController($timeout, $localStorage) {
        var $ctrl = this;
        var POPOVER_VISIBLE_DURATION_MS = 5000;
        var TYPE_NEW_TAB = 'new-tab';
        var TYPE_COPY = 'copy';
        var BUTTON_CLASS_BY_TYPE = {};
        BUTTON_CLASS_BY_TYPE[TYPE_COPY] = 'secondary-button';
        BUTTON_CLASS_BY_TYPE[TYPE_NEW_TAB] = 'create-new-btn';

        $ctrl.isLoading = false;
        $ctrl.popoverIsOpen = false;

        $ctrl.$onInit = function () {
            $ctrl.buttonId = $ctrl.buttonId || 'btnGenerateLink';
            $ctrl.buttonClass = BUTTON_CLASS_BY_TYPE[$ctrl.type] || BUTTON_CLASS_BY_TYPE[TYPE_COPY];
        };

        $ctrl.handleClick = function () {
            if ($ctrl.isLoading) {
                return;
            }

            var cachedLink = readCachedLink();
            if (cachedLink) {
                useLink(cachedLink.url);
                return;
            }

            $ctrl.isLoading = true;
            $ctrl.generateLink()
                .then(function (result) {
                    saveCachedLink(result.url, result.expiresAt);
                    useLink(result.url);
                })
                .catch(function (error) {
                    if ($ctrl.onError) {
                        $ctrl.onError({ error: error });
                    }
                })
                .finally(function () {
                    $ctrl.isLoading = false;
                });
        };

        function useLink(url) {
            if ($ctrl.type === TYPE_NEW_TAB) {
                window.open(url, '_blank');
                return;
            }
            copyToClipboard(url).then(function () {
                $ctrl.popoverIsOpen = true;
                $timeout(function () {
                    $ctrl.popoverIsOpen = false;
                }, POPOVER_VISIBLE_DURATION_MS);
            });
        }

        function readCachedLink() {
            if (!$ctrl.storageKey) {
                return null;
            }
            var cached = $localStorage[$ctrl.storageKey];
            if (cached && cached.url && cached.expiredAt && new Date(cached.expiredAt) > new Date()) {
                return cached;
            }
            return null;
        }

        function saveCachedLink(url, expiresAt) {
            if (!$ctrl.storageKey) {
                return;
            }
            $localStorage[$ctrl.storageKey] = { url: url, expiredAt: expiresAt };
        }
    }
})();
